import contactType from 'helpers/contact_type';

angular.module('gym.contacts').controller('EditMembershipRecurringAmountCtrl', ["$scope", "$rootScope", "$state", "$http", "$q", "flash", "ReactModal", "contact", "membership", function($scope, $rootScope, $state, $http, $q, flash, ReactModal, contact, membership) {
  var gym, validate;
  $scope.goToContact = function() {
    return $state.go('gym.contacts.edit', {
      contactType: contactType(contact.type),
      contactId: contact.id
    });
  };
  $scope.gym = gym = $rootScope.gym;
  $scope.membership = membership;
  if (!((membership != null ? membership.cost_repeat : void 0) > 0 && membership.plan_type === 'recurring' && (membership != null ? membership.active : void 0))) {
    $scope.goToContact();
    flash.error = 'Invalid membership';
  }
  $scope.data = {
    cost_repeat: membership.cost_repeat,
    overwrite_future_adjustments: false,
    rootObjectName: 'membership'
  };
  $scope.isReady = function() {
    return !$scope.isLoading && $scope.data.cost_repeat >= 1;
  };
  validate = function() {
    var deferred, url;
    deferred = $q.defer();
    url = `/gyms/${gym.id}/${contactType(contact.type)}/${contact.id}/memberships/${membership.id}/validate_recurring_amount_change`;
    $http.put(url, {
      membership: $scope.data
    }).then(function() {
      return deferred.resolve();
    }, function(response) {
      var ref;
      if ((ref = response.data.errors) != null ? ref.upcoming_credit_conflicts : void 0) {
        return ReactModal.open({
          component: 'UpcomingCreditConflictsModal',
          props: {
            upcomingCreditConflicts: response.data.errors.upcoming_credit_conflicts
          }
        }).then(function() {
          return deferred.resolve();
        }, function() {
          return deferred.reject();
        });
      } else {
        flash.error = "An error occurred performing the requested change. Reload the page and try again.";
        return deferred.reject();
      }
    });
    return deferred.promise;
  };
  return $scope.save = function() {
    $scope.data.errors = {};
    $scope.isLoading = true;
    return validate().then(function() {
      return contact.one('memberships', membership.id).doPUT($scope.data, 'update_recurring_amount').then(function() {
        flash.success = "Updated successfully";
        return $scope.goToContact();
      }, function(response) {
        $scope.isLoading = false;
        flash.error = response.data.error_message || response.data;
        return $scope.data.errors = response.data.errors || response.data;
      });
    }, function() {
      return $scope.isLoading = false;
    });
  };
}]);
